import * as React from 'react';
export default React.createContext(undefined);
//# sourceMappingURL=HeaderHeightContext.js.map